import QwDateEditorials from '@qwentes/qw-date-editorials';

export default class CommunicationToolListController {
  /* @ngInject */
  constructor(CommunicationToolService, RouterService, InfiniteTriggerService, AuthService, HttpService, GeographyService) {
    this.routerService = RouterService;
    this.infiniteTriggerService = InfiniteTriggerService;
    this.communicationToolService = CommunicationToolService;
    this.authService = AuthService;
    this.httpService = HttpService;
    this.geographyService = GeographyService;
  }

  $onInit() {
    this.categoryId = this.routerService.state.params.categoryId;
    this.onChangeEditorialFilters = this.onChangeEditorialFilters.bind(this);
    this.httpService
      .all([this.getCategory(this.categoryId), this.geographyService.storeDetail(this.authService.currentStoreId())])
      .then(results => this.onGetCategoryAndStoreDetailSuccess(results))
      .catch(console.log);
  }

  onGetCategoryAndStoreDetailSuccess(results) {
    this.currentCountryKey = results[1] && results[1].iso3166_1;
    if (!this.isEditorial) {
      this.getInitialTools();
      return;
    }

    this.getEditorialFilters()
      .then(data => this._atLeastOneEditorialFilters(data) ? this.formatForEditorials(data) : this.getInitialTools())
      .catch(console.log);
  }

  getCategory(categoryId) {
    return this.communicationToolService.getCategory(categoryId)
      .then((category) => {
        this.category = category;
        this.isEditorial = this.category.slug === 'EDITORIALS';
        return this.category;
      });
  }

  getEditorialFilters() {
    return this.communicationToolService.getEditorialFilters();
  }

  getInitialTools(params = {}) {
    this.getCollections({page: 1, online: 1, ...params})
      .then(newCollections => this.getCollectionsSuccess(newCollections))
      .catch(console.log);
  }

  getCollections(params) {
    return this.communicationToolService.collections(this.categoryId, params);
  }

  getCollectionsSuccess(newCollections) {
    this.collections = newCollections.collections;
    const category = this.collections[0] ? this.collections[0].category : {};
    this.breadcrumbs = [{label: 'Communication Tools'}, category];
    this.updatePagination(newCollections);
  }

  updateCollections() {
    if (this.httpUpdateCollectionsIsPending) {
      return;
    }

    this.httpUpdateCollectionsIsPending = true;
    this.getCollections({page: this.currentPage += 1})
      .then((newCollections) => {
        this.httpUpdateCollectionsIsPending = false;
        this.collections = [...this.collections, ...newCollections.collections];
        this.updatePagination(newCollections);
      });
  }

  updatePagination({total, page, perPage}) {
    this.totalProducts = total;
    this.currentPage = page;
    this.perPage = perPage;
  }

  hasMoreCollections() {
    return this.infiniteTriggerService.canLoadMoreItems({
      totalItems: this.totalProducts,
      itemsPerPage: this.perPage,
      currentPage: this.currentPage,
    });
  }

  onChangeEditorialFilters(active, formatted) {
    this.collections = null;
    this.currentPage = 1;
    this.preselectedEditorialFilters = {active, formatted};
    this.getInitialTools(formatted);
  }

  _atLeastOneEditorialFilters(editorialFiltersPayload) {
    return editorialFiltersPayload.countries.length ||
      editorialFiltersPayload.magazines.length ||
      editorialFiltersPayload.dates.original.length;
  }

  formatForEditorials(data) {
    this._onEditorialFiltersReady(data);
    const preselectedFilters = this._setEditorialPreselectedFilters(data);
    this.getInitialTools(preselectedFilters.formatted);
  }

  _onEditorialFiltersReady(data) {
    this.EDITORIALS = {
      COUNTRY: 'editorialsCountry',
      MAGAZINE: 'editorialsMagazine',
      START_DATE: 'editorialsStartDate',
      END_DATE: 'editorialsEndDate',
    };
    this.editorialFilters = [
      {name: this.EDITORIALS.COUNTRY, options: [{label: 'Country', value: undefined}, ...data.countries]},
      {name: this.EDITORIALS.MAGAZINE, options: [{label: 'Magazine', value: undefined}, ...data.magazines]},
      {name: this.EDITORIALS.START_DATE, options: [{label: 'From date', value: undefined}, ...data.dates.formatted]},
      {name: this.EDITORIALS.END_DATE, options: [{label: 'To date', value: undefined}, ...data.dates.formatted]},
    ];
  }

  _setEditorialPreselectedFilters(data) {
    this.preselectedEditorialFilters = {active: {}, formatted: {}};
    this._setPreselectedCountry(data.countries);
    this._setPreselectedDates(data.dates);
    return this.preselectedEditorialFilters;
  }

  _setPreselectedCountry(countries) {
    const currentCountryPreselected = countries
      .find(c => c.value === this.currentCountryKey) || {label: 'Country', value: undefined};
    this.preselectedEditorialFilters.active.editorialsCountry = currentCountryPreselected;
    this.preselectedEditorialFilters.formatted.editorialsCountry = currentCountryPreselected.value;
  }

  _setPreselectedDates(dates) {
    const now = new Date();
    const shouldBeStartMonth = now.getMonth() - 5;
    const isShouldBeStartMonthPositive = shouldBeStartMonth > 0;
    const startMonth = isShouldBeStartMonthPositive ? shouldBeStartMonth : shouldBeStartMonth + 12;
    const startYear = isShouldBeStartMonthPositive ? now.getFullYear() : now.getFullYear() - 1;
    const shouldBePreselectedStartValue = `${QwDateEditorials.stringifyElementOfDate(startMonth)}/${startYear}`;
    const shouldBePreselectedEndValue = `${QwDateEditorials.stringifyElementOfDate(now.getMonth() + 1)}/${now.getFullYear()}`;
    const formattedValuesArray = dates.formatted.map(d => d.value);
    const start = this._getPreselectedDateValue(shouldBePreselectedStartValue, formattedValuesArray, this.EDITORIALS.START_DATE);
    const end = this._getPreselectedDateValue(shouldBePreselectedEndValue, formattedValuesArray, this.EDITORIALS.END_DATE);
    this._setPreselectedDate(start, this.EDITORIALS.START_DATE);
    this._setPreselectedDate(end, this.EDITORIALS.END_DATE);
  }

  _getPreselectedDateValue(preselectedValue, range, type) {
    return !range.includes(preselectedValue)
      ? (type === this.EDITORIALS.START_DATE ? range[range.length - 1] : range[0])
      : preselectedValue;
  }

  _setPreselectedDate(date, valueToSet) {
    if (date) {
      const splitted = QwDateEditorials.getFirstAndLastDay(date);
      const correctDate = valueToSet === this.EDITORIALS.START_DATE ? splitted.first : splitted.last;
      this.preselectedEditorialFilters.active[valueToSet] = {value: date, label: date};
      this.preselectedEditorialFilters.formatted[valueToSet] = QwDateEditorials.formatRaw(correctDate);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/communication-tool/communication-tool-list/communication-tool-list.controller.js